import React, { useEffect, useState, useContext } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import pdfSVG from '../accests/pdf.svg'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AuthContext } from '../context/AuthContext'
import { useHttp } from '../hooks/http.hook'
import Dropdown from 'react-dropdown';
import { styled } from '@mui/material/styles';

import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import 'react-dropdown/style.css';
import DraftEditor from './Editor/DraftEditor';

import ReactQuill from 'react-quill';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Stack } from '@mui/material';
function preventDefault(event) {
    event.preventDefault();
}


const modules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote' ],
        ['link'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
               // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
         
         
         
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
         

                                                  // remove formatting button
    ]
}
const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
]
export default function DocumentsCompanyPostCreateComponents(props) {

    const { token, logout } = useContext(AuthContext)
    const [title, setTitle] = useState(null)
    const [text, setText] = useState('')
    const [more, setMore] = useState(null)
    const [preview, setPreview] = useState('')
    const [photo, setPhoto] = useState('')
    const [reload, setReload] = useState(null)
    const [postRows, setPostRows] = useState(new Map())
    const [optionsPost, setOptionsPost] = useState([])
    const [valueDropDownPost, setValueDropDownPost] = useState(null)
    const [documentRows, setDocumentRows] = useState(new Map())
    const [optionsDocument, setOptionsDocument] = useState([])
    const [valueDropDownDocument, setValueDropDownDocument] = useState(null)

    const { loading, request, error, clearError } = useHttp()

    const uploadDocuments = async (file) => {
        const fmData = new FormData();
        const config = {
            headers: { "content-type": "multipart/form-data", "authorization": `Bearer ${token}` },
            onUploadProgress: event => {
                const percent = Math.floor((event.loaded / event.total) * 100);

            }
        };
        fmData.append("file", file.target.files[0]);
        try {
            const res = await axios.post(
                "/api/files/download",
                fmData,
                config
            );

            // onSuccess("Ok");
            setText(res.data.filename)
        } catch (err) {
            setText('')
            console.log("Eroor: ", err);
            const error = new Error("Some error");
            // onError({ err });
        }
    };


    const getPost = async () => {
        const datat = await request('/api/companys_posts/', 'GET', null, {
            authorization: `${token}`
        }
        )
        if (datat) {
            let bufRows = []
            let bufRows2 = []
            //console.log(datat)
            for (let row of datat) {
                bufRows.push({ 'label': row.name, 'value': row.id })
                bufRows2.push({ 'name': row.name, 'id': row.id })
            }
            setPostRows(new Map(bufRows2.map(item => [item.id, item.name])))
            // console.log("new Map(bufRows2.map(item => [item.id, item.name]))", new Map(bufRows2.map(item => [item.id, item.name])))
            setOptionsPost(bufRows)
            // setValueDropDownPost({ value: props.select.companys_posts_id, label: postRows.get(props.select.companys_posts_id) })

        }
    }

    const getDocument = async () => {
        const datat = await request('/api/documents/', 'GET', null, {
            authorization: `${token}`
        }
        )
        if (datat) {
            let bufRows = []
            let bufRows2 = []
            //console.log(datat)
            for (let row of datat) {
                bufRows.push({ 'label': row.name, 'value': row.id })
                bufRows2.push({ 'name': row.name, 'id': row.id })
            }
            setDocumentRows(new Map(bufRows2.map(item => [item.id, item.name])))
            // console.log("new Map(bufRows2.map(item => [item.id, item.name]))", new Map(bufRows2.map(item => [item.id, item.name])))
            setOptionsDocument(bufRows)
            // setValueDropDownDocument({ value: props.select.documents_id, label: documentRows.get(props.select.documents_id) })

        }
    }

    React.useEffect(() => {
        if (props?.select) {
            //console.log(props?.select)

            // setTitle(props?.select?.name ?? '')
            // setText(props?.select?.path ?? '')
            setValueDropDownDocument({ value: props.select.documents_id, label: documentRows.get(props.select.documents_id) })
            setValueDropDownPost({ value: props.select.companys_posts_id, label: postRows.get(props.select.companys_posts_id) })

        }

    }, [props])

    React.useEffect(() => {
        
        getDocument()
        getPost()
        // getMaking()
    }, [])

    React.useEffect(() => {
        if (reload) {
            props.update()
            setTitle('')
            setText('')
            setReload(null)

        }
    }, [reload])

    // useEffect(() => {
    //     console.log("select", valueDropDown)
    // }, [valueDropDown])

    const updateRow = async () => {
        if (props?.select && (props?.select?.documents_id != valueDropDownDocument.value || props?.select?.companys_posts_id != valueDropDownPost.value)) {
            let data
            if (more) {
                data = await request(`/api/companys_posts_documents/${props.select.id}`, 'PUT', { documents_id: valueDropDownDocument.value, companys_posts_id: valueDropDownPost.value }, {
                    authorization: `${token}`
                })
            } else {
                data = await request(`/api/companys_posts_documents/${props.select.id}`, 'PUT', { documents_id: valueDropDownDocument.value, companys_posts_id: valueDropDownPost.value }, {
                    authorization: `${token}`
                })
            }
            if (data) {
                setReload(1)
            }
        }

    }

    const createRow = async () => {
        if (valueDropDownDocument && valueDropDownPost) {
            const data = await request(`/api/companys_posts_documents/`, 'POST', { documents_id: valueDropDownDocument.value, companys_posts_id: valueDropDownPost.value }, {
                authorization: `${token}`
            })
            if (data) {
                setReload(1)
            }
        }

    }
    const deleteRow = async () => {
        if (valueDropDownDocument && valueDropDownPost && props.select) {
            const data = await request(`/api/companys_posts_documents/${props.select.id}`, 'DELETE', null, {
                authorization: `${token}`
            })
            setReload(1)
        }

    }
    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });
    // useEffect(()=>{
    //     //console.log((props?.select?.text!=text && props?.select?.name!=title))
    // },[text, title])

    return (
        <React.Fragment>
            <Grid container direction="column" spacing={2} sx={{ width: "100%" }}>
                <Grid item xs={12}>
                    <Dropdown
                        options={optionsPost}
                        // disabled={props?.select ? "" : "1"}
                        value={valueDropDownPost}
                        onChange={(e) => setValueDropDownPost(e)}
                        placeholder="Выберите запись" />
                </Grid>
                <Grid item xs={12}>
                    <Dropdown
                        options={optionsDocument}
                        // disabled={props?.select ? "" : "1"}
                        value={valueDropDownDocument}
                        onChange={(e) => setValueDropDownDocument(e)}
                        placeholder="Выберите документ" />

                </Grid>
                <Grid item xs={12}>
                    <Stack direction="row" spacing={1} flexWrap="wrap">
                        <Button variant="contained"
                            onClick={updateRow}
                            disabled={(props?.select && (props?.select?.path != text || props?.select?.name != title)) ? "" : "1"}>Редактировать</Button>
                        <Button variant="contained"
                            onClick={createRow}
                        >Добавить</Button>
                        <Button variant="contained"
                            color="error"
                            onClick={deleteRow}
                            disabled={(props?.select) ? "" : "1"}
                        ><DeleteForeverIcon></DeleteForeverIcon></Button>
                    </Stack>
                </Grid>
            </Grid>

        </React.Fragment>
    );
}

